module.exports = __webpack_public_path__ + "img/despacho2.56e5b202.jpeg";